/**
 * Pod Point website main client entry
 */

import loadModules from "@pod-point/module-loader";
import combineDomModules from "@pod-point/dom-module-loader";
import * as dom from "@pod-point/dom-ops";
import * as Sentry from "@sentry/browser";
// Toolkit imports
import "@pod-point/pod-point-ui-toolkit/dist/assets/js/modules/base";
import accordion from "@pod-point/pod-point-ui-toolkit/dist/assets/js/modules/accordion";
import toggleElement from "@pod-point/pod-point-ui-toolkit/dist/assets/js/modules/toggle-element";
// DOM module imports
import ajaxEntry from "./modules/ajax-entry";
import anchorNav from "./modules/anchor-nav";
import backToTop from "./modules/back-to-top";
import carFilters from "./modules/car-filters";
import carousel from "./modules/carousel";
import chargerSelector from "./modules/charger-selector";
import checkboxReset from "./modules/checkbox-reset";
import checkboxToggle from "./modules/checkbox-toggle";
import headerNav from "./modules/header-nav";
import scrollToAnchor from "./modules/scroll-to-anchor";
import selectToggle from "./modules/select-toggle";
import tabs from "./modules/tabs";
import trackEvent from "./modules/track-event";
import trackForm from "./modules/track-form";
import trackVideo from "./modules/track-video";
import video from "./modules/video";

dom.whenReady(() => {
    loadModules({
        domModules: combineDomModules({
            accordion,
            ajaxEntry,
            anchorNav,
            backToTop,
            carFilters,
            carousel,
            chargerSelector,
            checkboxReset,
            checkboxToggle,
            headerNav,
            scrollToAnchor,
            selectToggle,
            tabs,
            toggleElement,
            trackEvent,
            trackForm,
            trackVideo,
            video,
        }),
    });

    // We wrap this in a rAF
    requestAnimationFrame(() => dom.removeClass(document.body, "no-js"));

    // Set up sentry error logging
    Sentry.init({
        dsn: "https://64db8d6798c6419098ea3f0a9cfcb117@app.getsentry.com/69776",
        allowUrls: [/https:\/\/pod-point\.com/],
        // Using defined list found here: https://docs.sentry.io/platforms/javascript/configuration/filtering/
        ignoreErrors: [
            // Random plugins/extensions
            "top.GLOBALS",
            // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
            "originalCreateNotification",
            "canvas.contentDocument",
            "MyApp_RemoveAllHighlights",
            "http://tt.epicplay.com",
            "Can't find variable: ZiteReader",
            "jigsaw is not defined",
            "ComboSearch is not defined",
            "http://loading.retry.widdit.com/",
            "atomicFindClose",
            // Facebook borked
            "fb_xd_fragment",
            // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
            // reduce this. (thanks @acdha)
            // See http://stackoverflow.com/questions/4113268
            "bmi_SafeAddOnload",
            "EBCallBackMessageReceived",
            // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
            "conduitPage",
        ],
    });
});
